import { create } from "zustand";

import { initialState } from "./helpers";

const useAppStore = create((set) => ({
  settings: { ...initialState },
  setSettings: (settings) =>
    set((state) => ({
      settings: {
        ...state.settings,
        ...settings,
      },
    })),
  reset: () =>
    set(() => ({
      settings: { ...initialState },
    })),
}));

export default useAppStore;
